import React, { useCallback, useContext } from 'react';

import { updateTaskEditorStateAction, updateTaskOnServerAction, discardNewTaskAction } from 'actions/task';
import PostField from 'components/feed/PostField';
import { useLocation } from 'react-router-dom';
import { css } from 'styled-components';

import { CREATE_TASK_PLACEHOLDER, SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';
import { sendTaskEvent, TASK_EVENTS } from 'constants/mixpanelHelper';

import MeshListContext from '../MeshListContext';

export default function TaskNameEdit({ taskId, taskKey, editorState, placeholder, employeeId, onNewTaskCreate }) {
  const { dispatch, setCreateNewInProgress } = useContext(MeshListContext);

  const location = useLocation();

  function updateEditorState(newEditorState) {
    dispatch(updateTaskEditorStateAction({ taskId, key: taskKey, editorState: newEditorState }));
  }

  function onEnter() {
    dispatch(updateTaskOnServerAction({ id: taskId, key: taskKey, employeeId, onNewTaskCreate }));

    setCreateNewInProgress(false);
    // onNewTaskCreate();
  }

  function onEscape() {
    dispatch(discardNewTaskAction());
    setCreateNewInProgress(false);
    // dispatch(disableTaskEditingAction({ taskId, key: taskKey }));
  }
  const sendCreateHashtagEvent = useCallback(() => {
    sendTaskEvent({
      pageType: SEARCH_WIDGET_TYPES.task,
      eventName: TASK_EVENTS.hashtagCreated,
      viewType: 'Card',
    });
  }, []);

  return (
    <PostField
      placeholder={placeholder ?? CREATE_TASK_PLACEHOLDER}
      editorState={editorState}
      updateEditorState={updateEditorState}
      editorStyles={editorStyles}
      useMentionFunctionality
      placeholderStyles={editorPlaceholderStyles}
      onEnter={onEnter}
      onEscape={onEscape}
      widgetType={SEARCH_WIDGET_TYPES.task}
      beforeCreateNewHashtag={sendCreateHashtagEvent}
      teamId={null} // this is the right fix, you will be able to create hashtag like this, not like in the above case
    />
  );
}

const editorPlaceholderStyles = css`
  font-size: ${(props) => props.theme.typography.body2.fontSize};
`;

const editorStyles = css`
  font-size: ${(props) => props.theme.typography.body2.fontSize};
  border-radius: 5px;
`;
